import { IPhoneNumberVerificationProps } from "../models";
import { OtpCodeForm } from "../otpCode/otpCodeForm";

export const PhoneNumberVerification = (
  props: IPhoneNumberVerificationProps
) => {
  const { otpCode, onOtpCodeChange } = props;
  return <OtpCodeForm value={otpCode} key={0} onChange={onOtpCodeChange} />;
};
